import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IssueDrawerService {
  readonly isOpen = signal(false);
  readonly issueId = signal<string | null>(null);
  readonly issueKey = signal<string | null>(null);

  openById(issueId: string): void {
    this.issueKey.set(null);
    this.issueId.set(issueId);
    this.isOpen.set(true);
  }

  openByKey(issueKey: string): void {
    this.issueId.set(null);
    this.issueKey.set(issueKey);
    this.isOpen.set(true);
  }

  /** @deprecated use openById */
  open(issueId: string): void {
    this.openById(issueId);
  }

  close(): void {
    this.isOpen.set(false);
    this.issueId.set(null);
    this.issueKey.set(null);
  }
}
